import {
    AutodeskIntegrationModel,
    CameraImageModel,
    CameraModel,
    IAutodeskIntegrationModel,
    ProjectModel,
} from 'api/models';
import { getApiUrl } from 'config/api-url';
import http from 'config/http';

/* -------------------------------------------------------------------------------------------------
 * Get Integration Viewer
 * -----------------------------------------------------------------------------------------------*/
export const getAutodeskIntegrationViewerDetails = async (token: string) => {
    const { data } = await http.get(`${getApiUrl()}/autodesk-integration`, { params: { token } });

    return {
        camera: CameraModel.fromObject(data.camera),
        project: ProjectModel.fromObject(data.project),
        integration: AutodeskIntegrationModel.fromObject(data.integration),
    };
};

/* -------------------------------------------------------------------------------------------------
 * Get Integration Images
 * -----------------------------------------------------------------------------------------------*/
export const getAutodeskIntegrationViewerImages = async (token: string, date?: string) => {
    const { data } = await http.get(`${getApiUrl()}/autodesk-integration/images`, {
        params: { token, date: date ? date : undefined },
    });

    const result = {
        startDate: data.startDate as string,
        endDate: data.endDate as string,
        images: CameraImageModel.fromObjectList(data.images),
    };

    return result;
};

/* -------------------------------------------------------------------------------------------------
 * Get Integration
 * -----------------------------------------------------------------------------------------------*/
export const getAutodeskIntegration = async (projectId: string, cameraId: string) => {
    try {
        const { data } = await http.get(
            `${getApiUrl()}/projects/${projectId}/cameras/${cameraId}/integrations/autodesk`
        );

        return AutodeskIntegrationModel.fromObject(data);
    } catch (err) {
        console.log(err);
        return null;
    }
};

/* -------------------------------------------------------------------------------------------------
 * Update Integration
 * -----------------------------------------------------------------------------------------------*/
export const updateAutodeskIntegration = async (
    projectId: string,
    cameraId: string,
    payload: Pick<IAutodeskIntegrationModel, 'type' | 'options' | 'refreshInterval'>
) => {
    const { data } = await http.post(`${getApiUrl()}/projects/${projectId}/cameras/${cameraId}/integrations/autodesk`, {
        integrationType: payload.type,
        options: payload.options,
        refreshInterval: payload.refreshInterval,
    });

    return AutodeskIntegrationModel.fromObject(data);
};

/* -------------------------------------------------------------------------------------------------
 * Remove Integration
 * -----------------------------------------------------------------------------------------------*/
export const deleteAutodeskIntegration = async (projectId: string, cameraId: string, integrationId: string) => {
    await http.delete(
        `${getApiUrl()}/projects/${projectId}/cameras/${cameraId}/integrations/autodesk/${integrationId}`
    );
};
